import { module } from 'angular';
import { UIRouter } from '@uirouter/angularjs';
import { APPLICATION_STATE_PROVIDER } from '@spinnaker/core';
import ConfigDetailLoader from 'kayenta/edit/configDetailLoader';
import CanaryConfigEdit from 'kayenta/edit/edit';
import CanaryConfigSave from 'kayenta/edit/save';
import Canary, { canaryStore } from 'kayenta/canary';
import SelectConfig from 'kayenta/edit/selectConfig';
import Report from 'kayenta/report/report';
import ResultDetailLoader from 'kayenta/report/detail/detailLoader';
import ExecutionListLoadStates from 'kayenta/report/list/loadStates';
import * as Creators from 'kayenta/actions/creators';
import { CanarySettings } from '../canary.settings';
export const CANARY_STATES = 'spinnaker.kayenta.canary.states';
module(CANARY_STATES, [APPLICATION_STATE_PROVIDER])
    .config([
    'applicationStateProvider',
    (applicationStateProvider) => {
        'ngInject';
        var _a, _b, _c;
        const configDetail = {
            name: 'configDetail',
            url: '/:id?copy&new',
            views: {
                detail: {
                    component: ConfigDetailLoader,
                    $type: 'react',
                },
                footer: {
                    component: CanaryConfigSave,
                    $type: 'react',
                },
            },
            params: {
                copy: { type: 'boolean', value: false, squash: true },
                new: { type: 'boolean', value: false, squash: true },
            },
            resolve: [
                {
                    token: 'configNameStream',
                    deps: [UIRouter],
                    resolveFn: (uiRouter) => uiRouter.globals.params$,
                },
            ],
        };
        const configDefault = {
            name: 'configDefault',
            url: '',
            views: {
                detail: {
                    component: SelectConfig,
                    $type: 'react',
                },
            },
        };
        const config = {
            name: 'canaryConfig',
            url: '/config',
            views: {
                canary: {
                    component: CanaryConfigEdit,
                    $type: 'react',
                },
            },
            children: [configDefault, configDetail],
            redirectTo: (transition) => transition.to().name + '.configDefault',
        };
        const reportDetail = {
            name: 'reportDetail',
            url: '/:configId/:runId',
            views: {
                detail: {
                    component: ResultDetailLoader,
                    $type: 'react',
                },
            },
            resolve: [
                {
                    token: 'resultIdStream',
                    deps: [UIRouter],
                    resolveFn: (uiRouter) => uiRouter.globals.params$,
                },
            ],
        };
        const reportDefault = {
            name: 'reportDefault',
            url: '',
            views: {
                detail: {
                    component: ExecutionListLoadStates,
                    $type: 'react',
                },
            },
        };
        const report = {
            name: 'report',
            url: '/report?count',
            views: {
                canary: {
                    component: Report,
                    $type: 'react',
                },
            },
            params: {
                count: {
                    type: 'int',
                    value: (_c = (_a = CanarySettings.defaultExecutionCount) !== null && _a !== void 0 ? _a : (_b = CanarySettings.executionsCountOptions) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 20,
                    squash: true,
                },
            },
            children: [reportDetail, reportDefault],
            redirectTo: (transition) => transition.to().name + '.reportDefault',
        };
        const canaryRoot = {
            abstract: true,
            name: 'canary',
            url: '/canary',
            views: {
                insight: {
                    component: Canary,
                    $type: 'react',
                },
            },
            data: {
                pageTitleSection: {
                    title: 'Canary',
                },
            },
            children: [config, report],
        };
        applicationStateProvider.addChildState(canaryRoot);
    },
])
    .run([
    '$uiRouter',
    '$window',
    '$rootScope',
    ($uiRouter, $window, $rootScope) => {
        $uiRouter.transitionService.onBefore({
            from: '**.configDetail.**',
            to: (state) => !state.name.includes('configDetail'),
        }, () => {
            canaryStore.dispatch(Creators.clearSelectedConfig());
        });
        $rootScope.$on('$stateChangeStart', (event) => {
            const state = canaryStore.getState();
            const warningMessage = 'You have unsaved changes.\nAre you sure you want to navigate away from this page?';
            if (state.selectedConfig && !state.selectedConfig.isInSyncWithServer) {
                if (!$window.confirm(warningMessage)) {
                    event.preventDefault();
                }
            }
        });
        $uiRouter.transitionService.onEnter({ to: '**.configDetail.**' }, () => {
            $window.onbeforeunload = () => {
                const state = canaryStore.getState();
                return (state.selectedConfig && !state.selectedConfig.isInSyncWithServer) || null;
            };
        });
        $uiRouter.transitionService.onExit({ from: '**.configDetail.**' }, () => {
            $window.onbeforeunload = undefined;
        });
        $uiRouter.transitionService.onSuccess({ to: '**.report.**' }, (transition) => {
            if (transition.params('from').count !== transition.params('to').count) {
                canaryStore.dispatch(Creators.setExecutionsCount({ count: transition.params('to').count }));
            }
        });
    },
]);
//# sourceMappingURL=data:application/json;base64,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